<template>
  <v-dialog v-model="dialogStoreManager" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="oee-theme">
        <v-btn icon dark @click="closePopup">
          <v-icon>fa-times-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-title>Nhập kho ngày (入库日) {{currentTime | display_date('DD-MM-YYYY')}}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap pa-3>
          <v-flex lg3 md3 sm3>
            <v-layout row wrap pa-3>
              <v-flex lg12 md12 sm12 pa-0 pt-6>
                <v-autocomplete label="Khách hàng (客户)" v-model="selectedCustomerID" :items="customers" :item-text="getCustomerText" item-value="ID" clearable></v-autocomplete>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 pt-6>
                <v-text-field
                  label="Mã lô (批號)"
                  v-model="packageCode"
                  class="input-group--focused"
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 ma-0>
                <v-layout row wrap pa-3>
                  <v-checkbox label="Nhập hàng TMĐT (电商)" v-model="isEcommerce"></v-checkbox>
                </v-layout>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <v-autocomplete label="Mã vận đơn (运单号)" ref="trancode" :items="suggestList" item-text="TransactionCode" item-value="TransactionCode"  v-model="currentItem.TransactionCode" :search-input.sync="search" class="input-group--focused" :rules="requireRules" @change="manualChanged" @keyup.enter="manualChanged"></v-autocomplete>
              </v-flex>
              <v-container>
                <v-row justify="end">
                  <v-col cols="auto">
                    <v-btn @click="saveBigPackage">NHẬP KG & LÔ (导入和创建货件)</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-layout>
          </v-flex>
          <v-flex lg9 md9 sm9>
            <v-layout pl-4 pr-2 pt-12 row>
              <v-flex lg12 md12 sm12>
                <v-data-table
                  :headers="headers"
                  :items="items"
                  :options.sync="pagination"
                  :server-items-length="total_rows"
                  :footer-props="items_per_page"
                  :must-sort="true"
                  
                  :mobile-breakpoint="100"
                >
                  <template v-slot:item="{ item, index }">
                    <tr v-bind:class="{ 'warning-line': item.IsFragileGoods || item.IsCheck || item.OrderGuarantee}">
                      <td>
                        {{ total_rows - index }}
                      </td>
                      <td>{{ item.TransactionCode }}</td>
                      <td v-bind:class="{ 'required_line': !item.ProductName }">
                        <v-edit-dialog
                          :return-value.sync="item.ProductName"
                          large
                          lazy
                          persistent
                          @save="saveItem({'ID': item.ID, 'ProductName': item.ProductName})"
                        >
                          <div>{{ item.ProductName }}</div>
                          <template v-slot:input>
                            <v-text-field
                              v-model="item.ProductName"
                              single-line
                              autofocus
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-end" v-bind:class="{ 'required_line': !item.NumberOfPack }">
                        <h-currency-input label="Số kiện" v-model="item.NumberOfPack" :decimal="0" showClass="input-group--focused" @on_blur="saveItem({'ID': item.ID, 'NumberOfPack': item.NumberOfPack})" @press_enter="saveItem({'ID': item.ID, 'NumberOfPack': item.NumberOfPack})"></h-currency-input>
                      </td>
                      <td class="text-end" v-bind:class="{ 'required_line': !item.Weight }">
                        <h-currency-input :ref="'tranweight'+index" :id="'tranweight'+index" label="Cân nặng" v-model="item.Weight" :decimal="2" showClass="input-group--focused" @on_blur="saveItem({'ID': item.ID, 'Weight': item.Weight})" @press_enter="saveItem({'ID': item.ID, 'Weight': item.Weight}, true)"></h-currency-input>
                      </td>
                      <td class="text-end">
                        <h-currency-input label="Chiều dài" v-model="item.Length" :decimal="2" showClass="input-group--focused" @on_blur="saveItem({'ID': item.ID, 'Length': item.Length})" @press_enter="saveItem({'ID': item.ID, 'Length': item.Length}, true)"></h-currency-input>
                      </td>
                      <td class="text-end">
                        <h-currency-input label="Chiều rộng" v-model="item.Width" :decimal="2" showClass="input-group--focused" @on_blur="saveItem({'ID': item.ID, 'Width': item.Width})" @press_enter="saveItem({'ID': item.ID, 'Width': item.Width}, true)"></h-currency-input>
                      </td>
                      <td class="text-end">
                        <h-currency-input label="Chiều cao" v-model="item.Height" :decimal="2" showClass="input-group--focused" @on_blur="saveItem({'ID': item.ID, 'Height': item.Height})" @press_enter="saveItem({'ID': item.ID, 'Height': item.Height}, true)"></h-currency-input>
                      </td>
                      <td>
                        <v-select
                            :items="product_types"
                            v-model="item.ProductType"
                            item-text="Name"
                            item-value="ID"
                            @change="saveItem({'ID': item.ID, 'ProductType': item.ProductType})"
                        ></v-select>
                      </td>
                      <td>{{ item.Username || 'Vô chủ' }}</td>
                      <td>
                        {{ item.IsFragileGoods ? 'Đóng gỗ' : '' }}
                        <br v-if="item.IsFragileGoods" />
                        {{ item.IsCheck ? 'Kiểm hàng' : '' }}
                        <br v-if="item.IsCheck" />
                        {{ item.OrderGuarantee ? 'Bảo hiểm' : '' }}
                        <br v-if="item.GuaranteeType" />
                        {{ item.IsOfficialQuota ? 'Chính ngạch' : '' }}
                        <br v-if="item.IsOfficialQuota" />
                        {{ item.IsEcommerce ? 'TMĐT' : '' }}
                      </td>
                      <td class="text-end" v-bind:class="{ 'required_line': !item.FeeShip }">
                        <h-currency-input label="Phí ship" v-model="item.FeeShip" :decimal="1" showClass="input-group--focused" @on_blur="saveItem({'ID': item.ID, 'FeeShip': item.FeeShip})" @press_enter="saveItem({'ID': item.ID, 'FeeShip': item.FeeShip})"></h-currency-input>
                      </td>
                      <td class="truncate">
                        <v-text-field v-model="item.StoreCNNote" label="Ghi chú" @change="saveItem({'ID': item.ID, 'StoreCNNote': item.StoreCNNote}, true)" @keyup.enter="saveItem({'ID': item.ID, 'StoreCNNote': item.StoreCNNote}, true)"></v-text-field>
                      </td>
                      <td class="text-center">
                        <v-icon small @click="deleteItem(item.ID)">fa-trash-alt</v-icon>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-dialog v-model="dialogPrinter" width="500">
        <v-card>
          <v-card-title class="text-h6 grey lighten-2">
            成功创建新货件
          </v-card-title>
          <v-card-text style="padding: 30px;">
            <h1 class="red--text">{{ currentBigPackage.PackageCode }}</h1>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="printPackage()">
              In tem (打印)
            </v-btn>
            <v-btn color="primary" text @click="dialogPrinter = false">
              Đóng (关闭)
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import _ from "lodash";
import moment from "moment";
import { getCurrentTime, playSound, sendErrorNotice } from "@/commons/utils";
import { print_bigpackage } from "@/commons/hpod";
export default {
  name: "store-popup",
  data() {
    let configPaging = _.cloneDeep(configs.PAGINATION);
    configPaging.itemsPerPage = 100;
    return {
      selected: [],
      selectedCustomerID: 0,
      dialogCreateDeposit: false,
      isEcommerce: false,
      moveFocusToWeight: false,
      packageCode: '',
      dialogPrinter: false,
      lastTransactionCode: '',
      queryTerm: '',
      SessionID: null,
      currentItem: {
        TransactionCode: "",
        ProductType: 1,
        FeeShip: 0
      },
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      pagination: configPaging,
      items_per_page: { "items-per-page-options": [8] },
      currentTime: getCurrentTime(),
      timer: null,
    };
  },
  props: ["dialogStoreManager"],
  watch: {
    dialogStoreManager() {
      if (this.dialogStoreManager) {
        this.getListData();
        this.$nextTick(() => this.$refs.trancode.focus());
        this.currentItem.TransactionCode = "";
      }
    },
    items() {
      const lastItem = _.find(this.items, {'TransactionCode': this.lastTransactionCode});
      if(lastItem && (lastItem.IsFragileGoods || lastItem.IsCheck || lastItem.OrderGuarantee)) {
        playSound('/fire_alarm.mp3')
      }
    }
  },
  created() {
    this.timer = setInterval(this.moveFocus, 100);
    this.SessionID = sessionStorage.getItem("store_session_id");
    if(!this.SessionID) {
      this.SessionID = moment().unix();
      sessionStorage.setItem("store_session_id", this.SessionID);
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
  computed: {
    ...mapState({
      items: state => state.orderTransaction.listOfDay.data,
      suggestList: state => state.orderTransaction.suggestList.data,
      total_rows: state => state.orderTransaction.listOfDay.total,
      loading: state => state.orderTransaction.loading,
      customers: state => state.customer.master.data,
      product_types: state => state.productType.all.data,
      currentBigPackage: state => state.bigPackage.selected,
    }),
    search: {
      get () {
        return this.queryTerm
      },
      
      set (searchInput) {
        if (this.queryTerm !== searchInput) {
          this.queryTerm = searchInput;
        }
      }
    },
    filterData() {
      return [
        {
          column: "SessionID",
          value: this.SessionID,
          condition: "equal"
        },
        {
          column: "Status",
          value: configs.PACKAGE_STATUS_ENUM.DA_VE_TQ,
          condition: "equal"
        }
      ]
    },
    isChinessLanguage() {
      return false;
    },
    headers() {
      let tmp = [
          {
            text: "STT",
            value: "index",
            width: 60,
            sortable: false
          },
          {
            text: "Mã vận đơn (运单号)",
            value: "TransactionCode",
            filterable: true,
            quickSearch: true,
            width: 100,
            dataType: configs.DATA_TYPE["String"]
          },
          {
            text: "Tên hàng (中文品名)",
            value: "ProductName",
            filterable: true,
            quickSearch: true,
            width: 100,
            dataType: configs.DATA_TYPE["String"]
          },
          {
            text: "Số kiện (件数)",
            value: "NumberOfPack",
            align: "end",
            width: 100,
            filterable: true,
            dataType: configs.DATA_TYPE["Number"]
          },
          {
            text: "Cân nặng (重量)",
            value: "Weight",
            width: 100,
            filterable: true,
            align: "right",
            dataType: configs.DATA_TYPE["Number"]
          },
          {
            text: "Chiều dài (长)",
            value: "Length",
            filterable: true,
            width: 80,
            align: "right",
            dataType: configs.DATA_TYPE["Number"]
          },
          {
            text: "Chiều rộng (宽)",
            value: "Width",
            filterable: true,
            width: 80,
            align: "right",
            dataType: configs.DATA_TYPE["Number"]
          },
          {
            text: "Chiều cao (高)",
            value: "Height",
            filterable: true,
            width: 80,
            align: "right",
            dataType: configs.DATA_TYPE["Number"]
          },
          {
            text: "Loại hàng (产品类别)",
            value: "ProductType",
            filterable: true,
            width: 120,
            dataType: configs.DATA_TYPE["Enum"],
            values: []
          },
          {
            text: "Khách hàng (客户)",
            value: "Username",
            width: 100,
            filterable: true,
            quickSearch: true,
            dataType: configs.DATA_TYPE["String"]
          },
          {
            text: "Cảnh báo (警告)",
            sortable: false,
            filterable: false,
            width: 140,
          },
          {
            text: "Phí ship (到付)",
            value: "FeeShip",
            align: "end",
            width: 100,
            filterable: true,
            dataType: configs.DATA_TYPE["Number"]
          },
          {
            text: "Ghi chú (备注)",
            value: "StoreCNNote"
          },
          {
            text: "Thao tác (操作)",
            value: "",
            align: "center",
            sortable: false,
            filterable: false
          }
        ];
        return tmp;
    }
  },
  methods: {
    moveFocus() {
      // if(this.isEcommerce && this.moveFocusToWeight && this.$refs.tranweight0 !== undefined) {
      //   this.$refs.tranweight0.$el.querySelector('input').focus();
      //   this.$refs.tranweight0.$el.querySelector('input').select();
      //   this.moveFocusToWeight = false;
      // }
    },
    closePopup() {
      this.$emit("closePopup");
    },
    deleteItem(id) {
      this.$emit("deleteItem", id);
    },
    saveItem(item, changeFocus = false) {
        this.$store.dispatch("orderTransaction/setDetail", {
          data: item,
          id: item.ID
        });
        if(changeFocus) {
          this.$nextTick(() => this.$refs.trancode.focus());
          this.currentItem.TransactionCode = "";
        }
    },
    manualChanged() {
      this.currentItem.TransactionCode = this.currentItem.TransactionCode == '' ? this.queryTerm : this.currentItem.TransactionCode;
      // Hàng lẻ, TMĐT - 快递、电商	/ Hàng phổ thông-普通	
      this.currentItem.ProductType = this.isEcommerce ? 2 : 1;
      if (this.currentItem.TransactionCode !== "") {
        this.appendTransactionCode();
      }
    },
    codeChanged() {
      if (this.currentItem.TransactionCode !== "" && this.useBarcodeReader) {
        this.appendTransactionCode();
      }
    },
    saveBigPackage() {
      let rightSeleted = _.filter(this.items, (p) => {return !p.OrderID;});
      if(rightSeleted.length > 0) {
        let newOrder = {Status: 16};
        newOrder.StoreTransactionCodes = rightSeleted;
        this.$store.dispatch("deposit/setDetail", {'data': newOrder});
      }
      

      this.SessionID = moment().unix();
      sessionStorage.setItem("store_session_id", this.SessionID);
      this.$store.dispatch("bigPackage/setDetail", {
        data: {
          'AutoGenCode': !this.packageCode,
          'ActionType': 'StoreAndPacked',
          'Status': -1,
          'Packages': _.map(this.items, "ID")
        },
        id: 0
      }).then(p => {
        if(p.status == 200) {
          this.$store.commit("bigPackage/setDetail", p);
          this.dialogPrinter = true;
        }
      });

      this.packageCode = "";
      this.selectedCustomerID= 0;
      this.getListData();
    },
    appendTransactionCode: _.debounce(
      function() {
        this.lastTransactionCode = this.currentItem.TransactionCode;
        const cust = _.find(this.customers, {'ID': this.selectedCustomerID});
        this.$store.dispatch("orderTransaction/setDetail", {
          data: {
            ...this.currentItem,
            UID: this.selectedCustomerID,
            Username: cust ? cust.Username : 'Vô chủ',
            Status: configs.PACKAGE_STATUS_ENUM.DA_VE_TQ,
            SessionID: this.SessionID,
            TransactionView: 'store_cn_popup'
          },
          param: {
            pagination: this.pagination,
            filter: this.filterData,
            quickFilter: []
          }
        }).then(p => {
          if(p.status == 200) {
            this.moveFocusToWeight = true;
            playSound('/success.mp3');
          }
          else {
            playSound('/error.mp3');
          }
        });
        this.currentItem = {
          ProductType: this.currentItem.ProductType,
          TransactionCode: "",
          FeeShip: 0
        };
        // this.$nextTick(() => this.$refs.trancode.focus());
      },
      100,
      {
        leading: false,
        trailing: true
      }
    ),
    getListData() {
      var param = {
        pagination: {
          ...configs.PAGINATION,
          itemsPerPage: 1000,
          sortBy: ["ModifiedDate"],
          sortDesc: [1],
        },
        filter: this.filterData,
        quickFilter: []
      };
      this.$store.dispatch("orderTransaction/getListOfDay", param);
      this.$store.dispatch("orderTransaction/getListSuggest", {filter: [{
          column: "Status",
          value: 1,
          condition: "equal",
        }]});
    },
    getCustomerText(item) {
      return `DL${item.ID} - ${item.Username}`
    },
    printPackage() {
      print_bigpackage(this.currentBigPackage.PackageCode, this.currentBigPackage.CreatedDate, this.currentBigPackage.ExDate, this.currentBigPackage.TotalSmallPack, this.currentBigPackage.Weight, this.currentBigPackage.Volume, this.currentBigPackage.ProductNumber);
      this.dialogPrinter = false;
    },
  },
  mounted() {
    this.$store.dispatch("productType/getList");
    this.$store.dispatch("customer/getCustomerList", {
      is_master: 1,
      fields: ["ID", "Username", "ReceivePlaceID", "ChinaStoreID"]
    });
    this.$root.$on("REQUEST_REFRESH_DATA", this.getListData);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.getListData);
  }
};
</script>
